import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";

import { panelApiKeyToLabelMap } from "../../constants/constants";

import "../../styles/status-code-details.scss";

const {
  modes: modesApiKeyToLabelMap,
  inpFaults: inpFaultsApiKeyToLabelMap,
  outFaults: outFaultsApiKeyToLabelMap,
  othFaults: othFaultsApiKeyToLabelMap,
} = panelApiKeyToLabelMap;

const StatusCodeDetails = ({ panelsStreetlightsInfoState = {} }) => {
  const panelsStreetlightsInfo = useSelector(
    (state) => state.dashboardReducer.panelsStreetlightsInfo
  );

  const getTotalCount = (statusCodeType) => {
    const statusData = panelsStreetlightsInfoState?.[statusCodeType];
    const totalCount = Object.keys(statusData).reduce((acc, key) => {
      return acc + statusData[key];
    }, 0);
    return totalCount || 0;
  };

  const { modes, inpFaults, outFaults, othFaults } =
    panelsStreetlightsInfoState || {};
  return (
    <div className="status-code-details">
      <Grid container>
        <Grid item xs={12} sm={3} className="scd-wrapper scd-oper">
          <div className="scd-info header header-oper">
            <span>Operational modes</span>
          </div>
          {Object.keys(modesApiKeyToLabelMap).map((keyItem) => {
            return (
              <div key={keyItem} className="scd-info">
                <span>{modesApiKeyToLabelMap[keyItem]}</span>
                <span>{modes[keyItem]}</span>
              </div>
            );
          })}
        </Grid>
        <Grid item xs={12} sm={3} className="scd-wrapper scd-inp-faults">
          <div className="scd-info header header-inp-faults">
            <span>Input faults</span>
            <span>{getTotalCount("inpFaults")}</span>
          </div>
          {Object.keys(inpFaultsApiKeyToLabelMap).map((keyItem) => {
            return (
              <div key={keyItem} className="scd-info">
                <span>{inpFaultsApiKeyToLabelMap[keyItem]}</span>
                <span>{inpFaults[keyItem]}</span>
              </div>
            );
          })}
        </Grid>
        <Grid item xs={12} sm={3} className="scd-wrapper scd-out-faults">
          <div className="scd-info header header-out-faults">
            <span>Output faults</span>
            <span>{getTotalCount("outFaults")}</span>
          </div>
          {Object.keys(outFaultsApiKeyToLabelMap).map((keyItem) => {
            return (
              <div key={keyItem} className="scd-info">
                <span>{outFaultsApiKeyToLabelMap[keyItem]}</span>
                <span>{outFaults[keyItem]}</span>
              </div>
            );
          })}
        </Grid>
        <Grid item xs={12} sm={3} className="scd-wrapper scd-other-faults">
          <div className="scd-info header header-other-faults">
            <span>Other faults</span>
            <span>{getTotalCount("othFaults")}</span>
          </div>
          {Object.keys(othFaultsApiKeyToLabelMap).map((keyItem) => {
            return (
              <div key={keyItem} className="scd-info">
                <span>{othFaultsApiKeyToLabelMap[keyItem]}</span>
                <span>{othFaults[keyItem]}</span>
              </div>
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
};

export default StatusCodeDetails;
